import { withNamespace } from '@ux/namespace-component';
import Close from '@ux/icon/x';
import React from 'react';
import Button from '@ux/button';

/**
 * Representation of a Header in the Dialog.
 */

export default withNamespace(({ namespace, children, onClick }) => {
  const close = typeof onClick === 'function' && (
    <Button
      aria-label='close'
      className={ namespace('modal-close') }
      data-action='close'
      data-dismiss='modal'
      design={ 'inline' }
      onClick={ onClick }
      icon={ <Close /> }
    />
  );

  return <div className={ namespace('modal-header') }>
    { close }
    <h2 className={ namespace('modal-title') }>{ children }</h2>
  </div>;
});
